import { Box, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

interface Props {
  message?: string;
}

declare module '@mui/x-data-grid' {
  interface NoRowsOverlayPropsOverrides {
    message?: string;
  }
}

const NoRowsOverlay: React.FC<Props> = ({ message }) => {
  const theme = useTheme();
  const { translation } = useTranslation();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: theme.custom.background.level2,
        p: 2,
        borderRadius: 1
      }}
    >
      <Typography color="textSecondary">{message ?? translation.no_data_available}</Typography>
    </Box>
  );
};

export default NoRowsOverlay;
